import { siteNames } from '@seek/melways-sites';

import { Environment } from 'src/app/shared/config/environments';
import { FEATURE_AI_AD_WRITING } from 'src/app/shared/featureToggle/constants';
import { incrementalRolloutStrategy } from 'src/app/shared/featureToggle/strategies';
import type {
  FeatureConfig,
  SiteSpecificFeatureConfigValue,
} from 'src/app/shared/featureToggle/types';
import { getSiteEnvConfig } from 'src/app/shared/featureToggle/utils/getSiteEnvConfig';

export const aiAdWritingFeature: FeatureConfig<SiteSpecificFeatureConfigValue> =
  {
    name: FEATURE_AI_AD_WRITING,
    value: {
      [Environment.DEV]: {
        [siteNames.employer.seek.au]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.nz]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.hk]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.id]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.my]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.ph]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.sg]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.th]: { enabled: true, percent: 100 },
      },
      [Environment.STAGING]: {
        [siteNames.employer.seek.au]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.nz]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.hk]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.id]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.my]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.ph]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.sg]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.th]: { enabled: true, percent: 100 },
      },
      [Environment.PROD]: {
        [siteNames.employer.seek.au]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.nz]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.hk]: {},
        [siteNames.employer.seek.id]: {},
        [siteNames.employer.seek.my]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.ph]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.sg]: { enabled: true, percent: 100 },
        [siteNames.employer.seek.th]: {},
      },
    },
    toFeature({ advertiserId, env }) {
      const siteEnvConfig = getSiteEnvConfig(this.value!, env);
      const isEnabledFlag = siteEnvConfig.enabled;
      const partOfRollout = incrementalRolloutStrategy(
        advertiserId,
        siteEnvConfig,
        this.name,
      );

      const enabled = isEnabledFlag === undefined ? undefined : partOfRollout;

      return {
        name: this.name,
        enabled,
      };
    },
  };
